import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import { ReferralUser } from '@type/referrals'
import Cookies from 'js-cookie'

/**
 * Get Referral Code and send tracking data
 */
const getReferralCode = ({
  code,
  isClick,
  country,
  platform,
  os,
}: {
  code: string
  isClick?: string
  country?: string
  platform?: string
  os?: string
}): Promise<ReferralUser> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    let URL = routes.REFERRAL + `/code/${code}?isClick=${isClick || 'false'}`
    if (country) {
      URL += `&country=${country}`
    }
    if (platform) {
      URL += `&platform=${platform}`
    }
    if (os) {
      URL += `&os=${os}`
    }
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.get(URL, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default getReferralCode
